"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Check = void 0;
var react_1 = __importDefault(require("react"));
var Check = function (props) { return (react_1.default.createElement("svg", __assign({ viewBox: "0 0 40 40", xmlns: "http://www.w3.org/2000/svg" }, props),
    react_1.default.createElement("g", null,
        react_1.default.createElement("path", { d: "M20 3.33337C10.8 3.33337 3.33337 10.8 3.33337 20C3.33337 29.2 10.8 36.6667 20 36.6667C29.2 36.6667 36.6667 29.2 36.6667 20C36.6667 10.8 29.2 3.33337 20 3.33337ZM20 33.3334C12.65 33.3334 6.66671 27.35 6.66671 20C6.66671 12.65 12.65 6.66671 20 6.66671C27.35 6.66671 33.3334 12.65 33.3334 20C33.3334 27.35 27.35 33.3334 20 33.3334ZM27.65 12.6334L16.6667 23.6167L12.35 19.3167L10 21.6667L16.6667 28.3334L30 15L27.65 12.6334Z", fill: "currentColor" })))); };
exports.Check = Check;
